<template>
  <div class="address__tools" id="lctActions">
    <v-menu top offset-y transition="scale-transition" content-class="address__tools-menu">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" :loading="gpsLoading">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-tile avatar @click="showPinOnMapForm" key="pinOnMapButton">
          <v-list-tile-avatar>
            <SvgIcon v-if="pinOnMapButton" :icon="pinOnMapButton" />
            <img v-else src="/v1/assets/images/ic-view-map.svg" height="16" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span style="white-space: nowrap">{{ $t('dropoff_address.form.pin_on_map') }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar @click="getCurrentLocation" key="getCurrentLocation">
          <v-list-tile-avatar v-if="!gpsOff">
            <SvgIcon v-if="currentLocationIcon" :icon="currentLocationIcon" />
            <v-icon v-else small color="grey">gps_fixed</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-avatar v-else>
            <SvgIcon v-if="noCurrentLocationIcon" :icon="noCurrentLocationIcon" />
            <v-icon v-else small color="grey">gps_off</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              <span style="white-space: nowrap">{{
                $t('dropoff_address.form.current_location')
              }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>

    <!-- <v-tooltip attach="#lctActions">
      <v-btn
        name="btnPinMap"
        slot="activator"
        icon
        small
        class="elevation-0 white"
        @click.stop="showPinOnMapForm"
      >
        <SvgIcon v-if="pinOnMapButton" :icon="pinOnMapButton" />
        <img v-else src="/v1/assets/images/ic-view-map.svg" height="16" />
      </v-btn>
      <span style="white-space: nowrap">{{$t('dropoff_address.form.pin_on_map')}}</span>
    </v-tooltip>

    <v-tooltip attach="#lctActions">
      <v-btn
        name="btnGPS"
        slot="activator"
        icon
        small
        :loading="gpsLoading"
        class="white elevation-0 gps-btn"
        @click.stop="getCurrentLocation"
      >
        <template v-if="!gpsOff">
          <SvgIcon v-if="currentLocationIcon" :icon="currentLocationIcon" />
          <v-icon v-else small color="grey">gps_fixed</v-icon>
        </template>
        <template v-else>
          <SvgIcon v-if="noCurrentLocationIcon" :icon="noCurrentLocationIcon" />
          <v-icon v-else small color="grey">gps_off</v-icon>
        </template>
      </v-btn>
      <span style="white-space: nowrap">{{$t('dropoff_address.form.current_location')}}</span>
    </v-tooltip> -->

    <SetPinOnMapViews
      name="btnSetPinLocation"
      v-if="pinOnMapFormVisible && !disableDragOnMap"
      :visible="pinOnMapFormVisible"
      :addressPoint="addressModel"
      @confirmAddress="handleConfirmedPinAddress"
      @dismiss="hidePinOnMapForm"
    />
  </div>
</template>

<script>
import loadSource from '@/mixins/load-source'
import addressHelper from '@/mixins/address-helper'
import SetPinOnMapViews from '@/components/new_order/SetPinOnMapViews'
import { getPlaceGeoReverse } from '@/plugins/place'

export default {
  name: 'Tools',
  props: {
    onChange: {
      type: Function
    },
    addressModel: {
      type: Object
    },
    pinOnMapButton: {
      type: String
    },
    currentLocationIcon: {
      type: String
    },
    noCurrentLocationIcon: {
      type: String
    },
    disableDragOnMap: {
      type: Boolean,
      default: false
    },
    onClickPinOnMap: {
      type: Function
    }
  },
  components: {
    SetPinOnMapViews
  },
  mixins: [loadSource, addressHelper],
  data() {
    return {
      pinOnMapFormVisible: false,
      gpsOff: false,
      gpsLoading: false
    }
  },
  methods: {
    showPinOnMapForm() {
      if (!this.disableDragOnMap) {
        this.pinOnMapFormVisible = true
      }

      this.$emit('onClickPinOnMap')
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.PICKUP_LOCATION_PIN_MAP_OPTION
      )
    },
    hidePinOnMapForm() {
      this.pinOnMapFormVisible = false
    },
    getCurrentLocation() {
      this.gpsLoading = true
      this.gpsOff = false
      return new Promise((resolve) => {
        if (!window.google) {
          this.loadGoogleMapApiJS().then(() => {
            resolve()
          })
        } else {
          resolve()
        }
      }).then(() => {
        this.$_addressHelper_getGPSLocation()
          .then((position) => {
            if (position && position.coords) {
              const latLng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
              getPlaceGeoReverse(latLng)
                .then((data) => {
                  data = { ...latLng, ...data }
                  this.$emit('onChange', data)
                  this.gpsLoading = false
                  this.loading = false
                })
                .catch((e) => {
                  this.gpsLoading = false
                  this.loading = false

                  // const error = {
                  //   visible: true,
                  //   color: 'error',
                  //   timeout: 4000,
                  //   title: this.$t('dropoff_address.geocode_error')
                  // }
                  // this.$store.dispatch('setSnackbar', error)
                  this.$_globalMixin_requestErrorHandle(e.response)
                })
            } else this.gpsLoading = false
          })
          .catch((e) => {
            if (e && e.code === 1 && e.message === 'User denied Geolocation') {
              let error = {
                visible: true,
                color: 'error',
                timeout: 1500,
                title: this.$t('dropoff_address.form.gps_off')
              }
              this.$store.dispatch('setSnackbar', error)
            } else {
              this.$_globalMixin_requestErrorHandle(e.response)
            }
            console.log(e)
            this.gpsOff = true
            this.gpsLoading = false
          })

        this.$analyticTracking.logEvent(
          this.$trackingEvents.ACTIONS.CLICK,
          this.$trackingEvents.EVENTS.PICKUP_LOCATION_GPS_BTN
        )

        this.$analyticTracking.logEvent(
          this.$trackingEvents.ACTIONS.CLICK,
          this.$trackingEvents.EVENTS.SEARCH_LOCATION_SELECT_CURRENT_LOCATION,
          {}
        )
      })
    },
    handleConfirmedPinAddress(data) {
      this.$emit('onChange', data)
      this.hidePinOnMapForm()
    }
  }
}
</script>

<style lang="scss" scoped>
.address__tools {
  display: inline-block;
  vertical-align: middle;
  align-items: center;

  .v-tooltip__content {
    min-width: 100px;
    right: 0;
    left: auto !important;
    bottom: 100%;
    top: auto !important;
  }

  .v-btn {
    margin: 4px 0;
  }
}
</style>
<style lang="scss">
.address__tools {
  .v-btn {
    &::before {
      border-radius: 4px !important;
      background: transparent !important;
    }

    &:hover {
      opacity: 0.8;
      // .v-btn__content {
      //   border: none;
      // }
    }

    .v-btn__content {
      border-left: 1px solid #eee;
      border-radius: 0;
    }
  }
}

.address__tools-menu {
  .v-list {
    .v-list__tile {
      font-size: 14px !important;
      padding: 0 12px 0 6px !important;
      height: 42px !important;

      .v-list__tile__avatar {
        min-width: initial !important;
        height: 42px !important;
      }
    }
  }
}
</style>
